<template>
    <input type="hidden" name="utm-campaign-url" />
</template>

<script>
import formMixin from '../../mixins/formMixin';

export default {
    mixins: [formMixin],
    methods: {
        /**
         * Uses window#postMessage to signal that this field
         * is ready to receive messages. This method will continue
         * to post messages until maxTries is reached
         *
         * @return {number} The interval ID
         */
        utmFieldReady() {
            let numTries = 0;
            const maxTries = 10;
            // interval in milliseconds
            const interval = 500;
            const intervalID = setInterval(function(){
                // signal to parent page iframe is ready to receive messages
                window.parent.postMessage({type: "mad-child-ready"}, "*");
                numTries++;
                if (numTries > maxTries){
                    clearInterval(intervalID);
                }
            }, interval);
            return intervalID;
        },

        /**
         * Listen to the message event for a utm campaign url
         *
         * @param {*} intervalID The interval ID
         */
        listenToUtmUrl(intervalID){
            window.addEventListener("message", function(event){
                if (event.data && event.data.type && event.data.type === 'mad-parent-utm'){
                    clearInterval(intervalID);
                    const utmURL = document.querySelector('input[name="utm-campaign-url"]');
                    if (utmURL){
                        utmURL.value = event.data.url;
                    }
                }
            }, false);
        },
    },

    async mounted() {
        // when this field is mounted, start listening for the utm campaign url
        this.listenToUtmUrl(this.utmFieldReady());
    }
};
</script>